import BreadcrumbIcon from 'assets/images/icons/BreadcrumbArrow.svg'
import { ICall } from 'features/calls/types'
import { PathsEnum } from 'pages/Paths'
import { useEffect, useRef, useState } from 'react'
import { FaArrowLeft } from 'react-icons/fa'
import { Button, Tooltip } from '@outbound-ai/ursa'
import styled, { css } from 'styled-components'
import { ColorsEnum, ColorsToneEnum, PositionEnum } from 'types/cssTypes'
import useWindowDimensions from 'utils/Utils'

const BREAD_CRUMB_SIZE = 102
// assets
// components
// paths
interface IProps {
  breadcrumbs?: { title: string; path?: PathsEnum | string }[]
  title: string
  titleComponent?: JSX.Element
  navComponent?: JSX.Element
  showBackButton?: boolean
  children?: JSX.Element
  showVerticalSeparator?: boolean
  backAction?: () => void
  suppressTooltip?: boolean
  isCallInProgress?: ICall
}

export const BreadcrumbHeader = ({
  title,
  navComponent,
  showBackButton = true,
  children,
  showVerticalSeparator = true,
  backAction,
  suppressTooltip,
  isCallInProgress,
}: IProps) => {
  const { windowWidth } = useWindowDimensions()

  const divRef = useRef<HTMLDivElement | null>(null)
  const [divWidth, setDivWidth] = useState(0)

  useEffect(() => {
    const handleResize = () => {
      if (divRef.current) {
        setDivWidth(divRef.current.offsetWidth)
      }
    }

    window.addEventListener('resize', handleResize)
    handleResize() // Initial measurement

    return () => window.removeEventListener('resize', handleResize) // Cleanup
  }, [children, isCallInProgress?.status])

  const renderShowBackButton = () =>
    showBackButton && (
      <Button
        variant="tertiary"
        radius="rounded"
        size="normal"
        onClick={() => {
          backAction && backAction()
        }}
      >
        <FaArrowLeft />
      </Button>
    )

  return (
    <Section className="breadcrumb-container" showVerticalSeparator={showVerticalSeparator}>
      <section className="left-section">
        {renderShowBackButton()}
        <div className="left-section-breadcrumbs">
          {/* {!!breadcrumbs?.length && (
            <Breadcrumb>
              {breadcrumbs!.map(({ title, path }, index) => (
                <Breadcrumb.Item key={index} {...(path ? { linkProps: { to: path }, linkAs: Link } : { active: true })}>
                  {title}
                </Breadcrumb.Item>
              ))}
            </Breadcrumb>
          )} */}
          <div className="navitems">{navComponent}</div>
          <div className="d-flex align-items-center mb-1">
            {!suppressTooltip ? (
              <Tooltip
                tooltipText={title}
                // showOnTextOverflow={true}
                position={PositionEnum.bottom}
                positionTooltipArrow={20}
                tooltipStyles={{
                  minWidth: '7rem',
                  left: '0',
                  transform: 'translateY(-110%) translateX(-20%)',
                }}
              >
                <h1
                  className="title"
                  data-testid="breadcrumb-section-title"
                  style={{ width: `${windowWidth - (divWidth + BREAD_CRUMB_SIZE)}px` }}
                >
                  {title}
                </h1>
              </Tooltip>
            ) : (
              <h1
                className="title"
                data-testid="breadcrumb-section-title1"
                style={{
                  width: `${windowWidth - (divWidth + BREAD_CRUMB_SIZE)}px`,
                }}
              >
                {title}
              </h1>
            )}
            {/* <div className="titleComponent"> {titleComponent}</div> */}
          </div>
        </div>
      </section>
      <section className="right-section" ref={divRef}>
        {children}
      </section>
    </Section>
  )
}

const Section = styled.section<{ showVerticalSeparator: boolean }>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-bottom: ${({ theme }) => theme.borders.s.solid(ColorsEnum.grey, ColorsToneEnum.lighter)};
  height: ${({ theme }) => theme.constants.navbarwithBreadcrumbsHeight};
  font-size: ${({ theme }) => theme.util.pixelToRem(24)};

  .left-section {
    display: flex;
    margin-left: ${({ theme }) => theme.spacing.l};
    button {
      margin-top: 1.5rem;
    }
    .titleComponent {
      margin-top: -30px !important;
    }
    & .left-section-breadcrumbs {
      display: flex;
      justify-content: center;
      flex-direction: column;
      padding-top: 0.5rem;
      margin-left: ${({ theme }) => theme.spacing.xxxs};

      .breadcrumb {
        margin-bottom: 0;
        & .breadcrumb-item {
          ${({ theme }) => theme.typography.xs.medium};
          & a {
            color: ${({ theme }) => theme.colors.info.neutral};
            text-decoration: underline;
          }
          & + .breadcrumb-item::before {
            /* variable is defined in bootstrap and here is overridden by BreadcrumbIcon, based on the UI design */
            content: var(--bs-breadcrumb-divider, ${() => `url(${BreadcrumbIcon})`});
            position: relative;
            bottom: 0.1rem;
          }
        }
      }

      h1.title {
        min-width: 9.375rem;
        ${({ theme }) => theme.typography.h4.bold};
        color: ${({ theme }) => theme.colors.primary.neutral};
        padding-block: 0.75rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  & .right-section {
    display: flex;
    /* flex: 1; */
    justify-content: end;
    align-items: center;
    margin: 0.5rem;
    margin-left: 1rem;
    margin-right: 1.5rem;
    /* ${({ showVerticalSeparator, theme }) =>
      showVerticalSeparator &&
      css`
        border-left: 0.0625rem solid ${theme.colors.primary.lighter};
      `} */
  }
`
